import React from 'react'


const PlayCourse = (props) =>
<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 286.054 286.054"><path d="M143.027.004C64.04.004 0 64.036 0 143.022c0 78.996 64.04 143.027 143.027 143.027s143.027-64.031 143.027-143.027c0-78.977-64.04-143.018-143.027-143.018zm0 259.228c-64.183 0-116.209-52.026-116.209-116.209s52.026-116.21 116.209-116.21 116.209 52.026 116.209 116.209-52.026 116.21-116.209 116.21zm57.836-122.798l-81.856-45.581c-5.962-3.638-11.827-.706-11.827 6.526v91.367c0 7.223 5.864 10.173 11.827 6.517l81.722-44.91c7.581-4.318 4.819-11.282.134-13.919z"/></svg>

export default PlayCourse


// WEBPACK FOOTER //
// ./src/components/_common/_icons/PlayCourse.js